import { API_METHOD } from "@/constants";
import { UploadScamEvidenceResponse as UploadImageResponse } from "@/types";

export async function uploadImage({
  file,
  isBusinessProfile,
  isScamEvidence,
}: {
  file: File;
  isBusinessProfile?: boolean;
  isScamEvidence?: boolean;
}): Promise<UploadImageResponse> {
  const formData = new FormData();
  formData.append("file", file);
  if (isScamEvidence !== undefined) {
    formData.append("isScamEvidence", "true");
  }
  if (isBusinessProfile !== undefined) {
    formData.append("isBusinessProfile", "true");
  }

  const res = await fetch(`/api/image`, {
    method: API_METHOD.POST,
    body: formData,
  });

  if (!res.ok) throw new Error("Upload failed");

  return res.json();
}

export async function uploadPublicImage(imagePath: string) {
  const resImage = await fetch(imagePath);
  if (!resImage.ok) throw new Error(`Failed to fetch ${imagePath}: ${resImage.status}`);

  const blob = await resImage.blob();
  const file = new File([blob], `${new Date().getTime()}.jpg`, { type: blob.type });
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`/api/image`, {
    method: API_METHOD.POST,
    body: formData,
  });

  if (!res.ok) throw new Error("Upload failed");

  return res.json();
}

export async function deleteImage(s3Key: string) {
  const res = await fetch(`/api/image`, {
    method: API_METHOD.DELETE,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(s3Key),
  });

  if (!res.ok) throw new Error("Delete failed");

  return res.json();
}
